import React from 'react';
import { MdOutlineLibraryAdd } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";
import { FaFolderOpen } from "react-icons/fa";
import { useState, useEffect } from "react";
import Products from './products';
import CreateProjectModal from './Modals/create_project_modal';
import axios from 'axios';
import ClipLoader from 'react-spinners/ClipLoader';
import { MdDeleteForever } from "react-icons/md";
import Swal from 'sweetalert2';
import { AxiosInstance } from '../../../common/Loader/axios.config';
import EditProjectModal from './Modals/update_project';


export default function Projects({ setOpenProvider, setSelectedProvider, provider }: { setOpenProvider: (open: boolean) => void, setSelectedProvider: (provider: any) => void, provider: any }) {
    const [openProject, setOpenProject] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [openProjectModal, setOpenProjectModal] = useState(false);
    const [openEditProjectModal, setOpenEditProjectModal] = useState(false);
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(false);

    // const AxiosInstance = axios.create({
    //     baseURL: 'https://dev.staticcomputersinc.com/kanemaonline',
    // });

    const fetchProjects = async (limit = 10, item = "") => {
        let skip = 0;
        let allProjects = [];
        let hasMore = true;

        console.log("Passed Provider", provider);

        while (hasMore) {
            try {
                const response = await AxiosInstance.get('/projects', {
                    params: {
                        skip,
                        limit,
                        item,
                    },
                });

                const projects = response.data.message;

                console.log("Projects Response", projects);

                // Filter projects based on the provider
                const filteredProjects = projects.filter(project => project.provider === provider);

                allProjects = [...allProjects, ...filteredProjects];

                hasMore = projects.length === limit;
                skip += limit;
            } catch (error) {
                console.error('Error fetching projects:', error);
                hasMore = false;
            }
        }

        const sortedProjects = allProjects.sort((a, b) => {
            return (
                new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
            );
        });
        setProjects(sortedProjects);
    };

    useEffect(() => {
        fetchProjects();
    }, []);

    const handleDeleteProject = async (ProjectID) => {
        try {
            setLoading(true);
            const response = await AxiosInstance.delete(`/${ProjectID}/project`);
            console.log("Delete Project Response", response);
            if (response.status == 200) {
                fetchProjects();
                Swal.fire({
                    icon: 'success',
                    title: 'Project deleted successfully!',
                    text: 'The project has been deleted successfully.',
                    showConfirmButton: false,
                    timer: 2000,
                });
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: 'Failed to delete provider',
                text: 'An error occurred while deleting the provider.',
            });
        }
    };


    return (
        <div className="w-full flex flex-col items-start justify-between">
            {openProject ? (<Products products={selectedProject?.products} setOpenProject={setOpenProject} setSelectedProject={setSelectedProject} project={selectedProject?._id} />) : (
                <div className='w-full'>
                    <div className="w-full flex items-center justify-between">
                        <div className='flex items-center text-lg font-bold text-white cursor-pointer hover:scale-105'
                            onClick={() => {
                                setOpenProvider(false);
                                setSelectedProvider(null);
                            }}
                        >
                            <IoIosArrowBack />
                            <p className="text-sm">Back</p>
                        </div>
                        <button className="flex items-center gap-x-1 rounded-lg bg-primary px-3 py-2 text-white duration-200 hover:scale-105"
                            onClick={() => setOpenProjectModal(true)}
                        >
                            <MdOutlineLibraryAdd size={20} />
                            <p className="font-bold text-lg">New</p>
                        </button>
                    </div>
                    <div className='w-full flex items-center justify-between'>
                        <p className="text-lg font-bold text-white">Projects</p>
                        <div></div>
                    </div>
                    <div className="grid grid-cols-3 gap-4 my-4">
                        {projects.map((project) => (
                            <div key={project.name} className="bg-white text-black rounded-lg shadow-lg p-4 cursor-pointer">
                                <img src={project.thumb_nail} alt={project.name} className="w-full h-40 object-cover mb-4" />
                                <h3 className="text-lg font-semibold mb-2">{project.name}</h3>
                                <p className="text-gray-600 mb-2">{project.category}</p>
                                <p className="text-gray-600 mb-2">Price: MWK {project.price}</p>
                                <div className="flex items-center gap-x-2">
                                    <button
                                        className="rounded-md bg-primary px-3 py-1 text-white"
                                        onClick={() => {
                                            setSelectedProject(project);
                                            setOpenEditProjectModal(true);
                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="flex items-center gap-x-1 rounded-md bg-primary px-3 py-1 text-white"
                                        onClick={() => {
                                            setSelectedProject(project);
                                            setOpenProject(true);
                                        }}
                                    >
                                        <FaFolderOpen size={18} />
                                        Open
                                    </button>

                                    <button className="rounded-md bg-brand-red p-2 text-white hover:scale-105 duration-200"
                                        onClick={() => {
                                            handleDeleteProject(project._id);
                                        }}
                                    >
                                        <MdDeleteForever size={18} />
                                    </button>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {openProjectModal && <CreateProjectModal isOpen={openProjectModal} onClose={() => setOpenProjectModal(false)} provider={provider} fetchProjects={fetchProjects} />}
            {openEditProjectModal && <EditProjectModal isOpen={openEditProjectModal} onClose={() => setOpenEditProjectModal(false)} selectedProject={selectedProject} fetchProjects={fetchProjects} />}
        </div>
    )
}